<script setup lang="ts">
import merge from 'lodash-es/merge';
import { useWebsitesStore } from '#layers/cms/app/pages/cms/management/websites/_runtime/stores/websites';

interface FormSettings
{
    settings: any;
}

defineOptions({
    name: 'WidgetIntGallerySettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref('int_gallery');
const defaults = ref<any>({
    pageId: null,
    display: '1'
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const displayOptions = computed((): Option[] =>
{
    return [
        { value: '4', text: $t('[[[4]]]') },
        { value: '8', text: $t('[[[8]]]') },
        { value: '12', text: $t('[[[12]]]') },
        { value: '16', text: $t('[[[16]]]') },
        { value: '20', text: $t('[[[20]]]') },
        { value: '24', text: $t('[[[24]]]') }
    ];
});

const current = computed<CurrentWebsite>(() =>
{
    return useWebsitesStore().current;
});

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            pageId: schema.string().nullable().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    await wait(() => current.value.website);
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Wybór strony]]]')" :invalid-feedback="form.$errors.first('settings.pageId')" :state="form.$errors.state('settings.pageId')" required>
        <EditoPageSelector v-model="form.settings.pageId" :module="module" :preview="false" label="" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Liczba wyświetlanych galerii]]]')" :invalid-feedback="form.$errors.first('settings.display')" :state="form.$errors.state('settings.display')">
        <IdeoFormSelect v-model="form.settings.display" :options="displayOptions" />
    </IdeoFormGroup>
</template>
